<ng-container  *transloco="let convert;">
  <div class="search-filters-mobile">
    <div class="header">
      <div class="d-flex justify-content-between">
        <div class="back-link">
          <button
            class="btn btn-link p-0"
            (click)="backClicked()"
            data-track-elem="button"
            [attr.data-track-name]="'Back to ' + resultsString"
            [attr.aria-label]="'Back to ' + resultsString"
            >
            <i class="me-1 allycon-glyph-chevron-left" aria-hidden="true"></i>
            <span [innerHTML]="convert('sellModule.manageInventory.mobileSearchFilter.textBack', {count:count | number: '1.0-0'})">@if (count > 1 || count === 0) {
              <span>s</span>
            }</span>
          </button>
        </div>
        <!-- <div>
        <button
          class="btn btn-link p-0"
          (click)="openSaveSearchModal('save-search-modal')"
          data-track-elem="button"
          data-track-name="Save Search"
          >
          Save Search
        </button>
      </div> -->
    </div>
  </div>
  <div class="body">
    <lib-search-filter [isMobile]="true"></lib-search-filter>
    @if (showDateRange) {
      <lib-utility-bar-date-range
        dpElNamespace="mobile"
        class="ms-auto pt-2 mobile-datepicker"
      ></lib-utility-bar-date-range>
    }
  </div>
</div>
</ng-container>
